import BottomSheetContent from '../BottomSheetComponents/BottomSheetContent'
import RenderHTML from '../ui-components/RenderHTML'
import { RightChevron } from '../../icons/questionnaire/RightChevron'
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import { trackEvent, onReady } from '../../utils/appBridge'
import { EventNames } from '../../types/misc.types'
import RiveComponent, { RiveFit } from '../RiveComponent'
import { useOpenR2dPlanSellRecommendationSheet } from './useOpenR2dPlanSellRecommendationSheet'

interface MultipleRecommendationsBottomSheetProps {
  isin: string
  onDismiss: () => void
  allocationPlanAvailable?: boolean
  rebalancePlanAvailable?: boolean
  allocationRecommended?: boolean
  rebalanceRecommended?: boolean
  timeToAllocationPlanDrop?: number
  timeToRebalancePlanDrop?: number
  isNewRebalance?: boolean
}

const AllocationPlanIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <g clip-path="url(#clip0_106723_190727)">
    <path d="M9.99512 0.664062C15.1529 0.664062 19.3347 4.84525 19.335 10.0029C19.335 12.5292 18.3299 14.8197 16.7002 16.501C16.6738 16.5401 16.644 16.5777 16.6094 16.6123C16.5751 16.6466 16.5377 16.6759 16.499 16.7021C14.8172 18.3353 12.5245 19.3428 9.99512 19.3428C4.83737 19.3425 0.65625 15.1608 0.65625 10.0029C0.656557 4.84539 4.83755 0.664289 9.99512 0.664062ZM9.25 2.2002C5.2704 2.57568 2.15654 5.92515 2.15625 10.0029C2.15625 14.3324 5.66579 17.8425 9.99512 17.8428C11.8909 17.8428 13.6287 17.1689 14.9844 16.0488L9.46973 10.5332C9.32925 10.3926 9.25 10.2017 9.25 10.0029V2.2002ZM10.75 9.69238L16.0459 14.9883C17.1636 13.6333 17.835 11.8964 17.835 10.0029C17.8347 5.92834 14.7252 2.58102 10.75 2.20117V9.69238Z" fill="#232323"/>
  </g>
  <defs>
    <clipPath id="clip0_106723_190727">
      <rect width="20" height="20" fill="white"/>
    </clipPath>
  </defs>
</svg>`

const RebalancePlanIcon = `
<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 18 18"><g stroke="#232323" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" clip-path="url(#a)"><path d="M4.922 1.426h5.826v5.826M10.747 1.426l-9.321 9.321M7.248 10.745v5.826h5.826M7.248 16.57 16.57 7.25"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h18v18H0z"/></clipPath></defs></svg>`

const RegularToDirectIcon = `
<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" fill="none" viewBox="0 0 19 19"><path fill="#232323" d="M2.83 11.63c1.375 0 2.272.81 2.272 2.055 0 .734-.37 1.38-1.007 1.737l1.784 2.962H4.035L2.521 15.74h-.877v2.644H.07L.05 11.63zm12.037-2.754a.764.764 0 0 1 1.056 0l2.242 2.17a.71.71 0 0 1 0 1.024.765.765 0 0 1-1.056 0l-.967-.936v2.6c0 1.999-1.673 3.618-3.736 3.618H9.167a.736.736 0 0 1-.747-.723c0-.4.335-.724.747-.724h3.239c1.237 0 2.242-.972 2.242-2.17v-2.6l-.966.935a.765.765 0 0 1-1.057 0 .71.71 0 0 1 0-1.023zM1.643 14.438h.917c.617 0 .966-.28.967-.753 0-.472-.35-.752-.967-.752h-.917zM6.496 1.043a.765.765 0 0 1 1.057 0l2.242 2.17a.71.71 0 0 1 0 1.024L7.553 6.408a.764.764 0 0 1-1.057 0 .71.71 0 0 1 0-1.023l.968-.937H4.782c-1.238 0-2.242.972-2.242 2.171V8.79c0 .4-.334.724-.747.724a.736.736 0 0 1-.747-.724V6.62C1.046 4.62 2.72 3 4.782 3h2.68l-.966-.935a.71.71 0 0 1 0-1.023M14.387.05c1.913 0 3.617 1.061 3.617 3.377S16.3 6.804 14.387 6.804h-2.38V.05zm-.837 5.442h.668c1.126 0 2.202-.502 2.202-2.065s-1.076-2.074-2.202-2.074h-.668z"/><path fill="#232323" d="M2.83 11.63v-.05zm2.272 2.055h.05zm-1.007 1.737-.024-.044-.045.025.026.045zm1.784 2.962v.05h.089l-.046-.076zm-1.844 0-.043.025.014.025h.03zM2.521 15.74l.043-.025-.014-.025h-.03zm-.877 0v-.05h-.05v.05zm0 2.644v.05h.05v-.05zm-1.574 0H.02v.05h.05zM.05 11.63v-.05H0v.05zm14.817-2.754-.035-.036zm1.056 0 .035-.036zm2.242 2.17.035-.035zm0 1.024.035.036zm-1.056 0-.035.036zm-.967-.936.035-.036-.085-.082v.118zm0 2.6h.05zm-3.736 3.618v.05zm-3.239 0v.05zm-.747-.723h-.05zm.747-.724v-.05zm3.239 0v.05zm2.242-2.17h.05zm0-2.6h.05v-.118l-.085.082zm-.966.935.035.036zm-1.057 0-.034.036zm0-1.023.035.036zm-10.981 3.39h-.05v.05h.05zm1.884-.751h.05zm-1.884-.753v-.05h-.05v.05zm4.852-11.89-.034-.036zm1.057 0 .035-.036zm2.242 2.17.035-.035zm0 1.024.035.036zM7.553 6.408l-.035-.036zm-1.057 0-.034.036zm0-1.023-.034-.036zm.968-.937.035.036.089-.086h-.124zm-2.682 0v-.05zM2.54 6.62h-.05zm-.747 2.895v.05zm-.747-2.895h-.05zm3.736-3.618v-.05zm2.68 0v.05h.124l-.09-.086zm-.966-.935-.034.036zm11.508 1.36h.05zm-5.998 3.378h-.05v.05h.05zm0-6.754V0h-.05v.05zm1.544 5.442h-.05v.05h.05zm2.87-2.065h.05zm-2.87-2.074v-.05h-.05v.05zM2.83 11.63v.05c.678 0 1.233.2 1.618.548s.604.848.604 1.457h.1c0-.634-.23-1.162-.637-1.531-.407-.368-.988-.574-1.685-.574zm2.272 2.055h-.05c0 .716-.36 1.345-.981 1.693l.024.044.024.043a2 2 0 0 0 1.033-1.78zm-1.007 1.737-.043.026 1.784 2.962.043-.026.043-.026-1.784-2.962zm1.784 2.962v-.05H4.035v.1H5.88zm-1.844 0 .044-.025-1.515-2.644-.043.025-.044.025 1.515 2.644zM2.521 15.74v-.05h-.877v.1h.877zm-.877 0h-.05v2.644h.1V15.74zm0 2.644v-.05H.07v.1h1.574zm-1.574 0h.05L.1 11.63H0l.02 6.754zM.05 11.63v.05h2.78v-.1H.05zm14.817-2.754.034.036a.715.715 0 0 1 .987 0l.035-.036.035-.036a.815.815 0 0 0-1.126 0zm1.056 0-.035.036 2.243 2.17.034-.035.035-.036-2.242-2.17zm2.242 2.17-.034.037a.66.66 0 0 1 0 .951l.034.036.035.036a.76.76 0 0 0 0-1.095zm0 1.024-.034-.036a.715.715 0 0 1-.988 0l-.034.036-.035.036a.814.814 0 0 0 1.126 0zm-1.056 0 .034-.036-.966-.936-.035.036-.035.036.967.936zm-.967-.936h-.05v2.6h.1v-2.6zm0 2.6h-.05c0 1.97-1.65 3.568-3.686 3.568v.1c2.089 0 3.786-1.64 3.786-3.668zm-3.736 3.618v-.05H9.167v.1h3.239zm-3.239 0v-.05a.686.686 0 0 1-.697-.673h-.1c0 .429.358.773.797.773zm-.747-.723h.05c0-.37.31-.674.697-.674v-.1a.786.786 0 0 0-.797.774zm.747-.724v.05h3.239v-.1H9.167zm3.239 0v.05c1.264 0 2.292-.993 2.292-2.22h-.1c0 1.17-.98 2.12-2.193 2.12zm2.242-2.17h.05v-2.6h-.1v2.6zm0-2.6-.035-.036-.966.935.035.036.035.036.965-.935zm-.966.935-.035-.036a.715.715 0 0 1-.987 0l-.035.036-.034.036a.815.815 0 0 0 1.126 0zm-1.057 0 .035-.036a.66.66 0 0 1 0-.951l-.035-.036-.034-.036a.757.757 0 0 0 0 1.095zm0-1.023.035.036 2.241-2.171-.034-.036-.035-.036-2.242 2.171zm-10.981 3.39v.05h.917v-.1h-.917zm.917 0v.05c.315 0 .57-.07.746-.209a.72.72 0 0 0 .27-.592h-.1a.62.62 0 0 1-.232.513c-.153.12-.382.188-.684.188zm.967-.751h.05a.72.72 0 0 0-.271-.594c-.177-.138-.43-.21-.746-.21v.1c.302 0 .531.07.684.19a.62.62 0 0 1 .233.513zm-.967-.753v-.05h-.917v.1h.917zm-.917 0h-.05v1.505h.1v-1.505zm4.852-11.89.035.036a.715.715 0 0 1 .987 0l.035-.036.035-.036a.815.815 0 0 0-1.126 0zm1.057 0-.035.036 2.242 2.17.035-.035.035-.036-2.242-2.171zm2.242 2.17-.035.037a.66.66 0 0 1 0 .951l.035.036.035.036a.76.76 0 0 0 0-1.095zm0 1.024-.035-.036-2.242 2.171.035.036.035.036 2.242-2.17zM7.553 6.408l-.035-.036a.714.714 0 0 1-.987 0l-.035.036-.034.036a.814.814 0 0 0 1.126 0zm-1.057 0 .035-.036a.66.66 0 0 1 0-.951l-.035-.036-.034-.036a.76.76 0 0 0 0 1.095zm0-1.023.035.036.968-.937-.035-.036-.035-.036-.967.937zm.968-.937v-.05H4.782v.1h2.682zm-2.682 0v-.05c-1.264 0-2.292.993-2.292 2.221h.1c0-1.17.98-2.12 2.192-2.12zM2.54 6.62h-.05V8.79h.1V6.62zm0 2.171h-.05c0 .37-.31.674-.697.674v.1a.786.786 0 0 0 .797-.774zm-.747.724v-.05a.686.686 0 0 1-.697-.674h-.1c0 .429.359.774.797.774zm-.747-.724h.05V6.62h-.1v2.17zm0-2.17h.05c0-1.97 1.65-3.569 3.686-3.569v-.1c-2.089 0-3.786 1.64-3.786 3.668zM4.782 3v.05h2.68v-.1h-2.68zm2.68 0 .035-.036-.966-.935-.035.036-.034.036.965.935zm-.966-.935.035-.036a.66.66 0 0 1 0-.951l-.035-.036-.034-.036a.76.76 0 0 0 0 1.095zM14.387.05V.1c.948 0 1.84.263 2.494.808.653.545 1.073 1.374 1.073 2.519h.1c0-1.172-.431-2.03-1.11-2.595C16.27.267 15.353 0 14.388 0zm3.617 3.377h-.05c0 1.144-.42 1.974-1.073 2.518-.654.546-1.546.809-2.494.809v.1c.965 0 1.882-.268 2.558-.832.677-.565 1.11-1.424 1.11-2.595zm-3.617 3.377v-.05h-2.38v.1h2.38zm-2.38 0h.05V.05h-.1v6.754zm0-6.754V.1h2.38V0h-2.38zm1.543 5.442v.05h.668v-.1h-.668zm.668 0v.05c.57 0 1.132-.127 1.554-.457.424-.332.698-.864.698-1.658h-.1c0 .769-.264 1.27-.66 1.58-.397.31-.935.435-1.492.435zm2.202-2.065h.05c0-.794-.274-1.329-.698-1.663-.421-.332-.985-.461-1.554-.461v.1c.556 0 1.094.126 1.492.44.396.312.66.815.66 1.584zm-2.202-2.074v-.05h-.668v.1h.668zm-.668 0h-.05v4.14h.1v-4.14z"/></svg>
`

type PlanNudgeBanner = {
  text: string
  backgroundColor: string
  textColor: string
}

/**
 * Same chemistry as pre-change rebalance nudge:
 * 1) plan available → Recommended
 * 2) else if drop time in future → Available in X days as part of {plan} plan
 * 3) else if drop time passed → Delayed…
 */
function getPlanNudgeBanner(
  planLabel: 'allocation' | 'rebalance',
  planAvailable: boolean,
  timeToPlanDrop?: number
): PlanNudgeBanner | null {
  if (planAvailable) {
    return { text: 'Recommended', backgroundColor: '#EFF9F0', textColor: '#2A9C4A' }
  }
  if (timeToPlanDrop === undefined) return null

  if (Date.now() < timeToPlanDrop) {
    const daysRemaining = Math.max(
      0,
      Math.ceil((timeToPlanDrop - Date.now()) / (1000 * 60 * 60 * 24))
    )
    return {
      text: `Available in ${daysRemaining} ${daysRemaining === 1 ? 'day' : 'days'} as part of ${planLabel} plan`,
      backgroundColor: '#EFF9F0',
      textColor: '#2A9C4A'
    }
  }

  return {
    text: "Delayed, we'll notify you when it's ready",
    backgroundColor: '#FDF4ED',
    textColor: '#D9892B'
  }
}

function RecommendationListItem({
  listItemTitle,
  listItemDescription,
  listItemIcon,
  onClick,
  banner
}: {
  listItemTitle: string
  listItemDescription: string
  listItemIcon: string
  onClick: () => void
  banner?: { text: string; backgroundColor: string; textColor: string } | null
}) {
  const card = (
    <button
      type="button"
      onClick={onClick}
      className="relative z-10 w-full px-3 py-4 border border-grey80 rounded-xl bg-white text-left"
    >
      <div className="flex flex-row items-center gap-2 justify-between">
        <div className="flex flex-row items-center gap-2 min-w-0">
          <div className="w-9 h-9 flex items-center justify-center shrink-0" aria-hidden>
            <RenderHTML innerHTMLText={listItemIcon} />
          </div>
          <div className="flex flex-col gap-1 min-w-0">
            <div className="text-sm text-black">{listItemTitle}</div>
            <div className="text-13 text-grey40 font-[400]">{listItemDescription}</div>
          </div>
        </div>
        <div aria-hidden>
          <RightChevron />
        </div>
      </div>
    </button>
  )

  if (!banner) return card

  // Stack banner above the card (no absolute overlap) so taller cards never clip the label
  return (
    <div
      className="w-full rounded-xl overflow-hidden"
      style={{ backgroundColor: banner.backgroundColor }}
    >
      <div
        className="flex flex-row items-center gap-2 font-medium text-13 px-5 py-2"
        style={{ color: banner.textColor }}
      >
        <div className="w-[14px] h-[14px] flex items-center justify-center" aria-hidden>
          <RiveComponent src="/rives/recommended.riv" fit={RiveFit.CONTAIN} className="w-full h-full" />
        </div>
        <div>{banner.text}</div>
      </div>
      {card}
    </div>
  )
}

/**
 * Bottom sheet when a regular fund has multiple plan recommendations
 * (allocation and/or rebalance, plus regular-to-direct).
 * Allocation / rebalance rows only when recommended + plan available.
 */
export default function MultipleRecommendationsBottomSheet({
  onDismiss,
  isin,
  allocationPlanAvailable = false,
  rebalancePlanAvailable = false,
  allocationRecommended = false,
  rebalanceRecommended = false,
  timeToAllocationPlanDrop,
  timeToRebalancePlanDrop,
  isNewRebalance = false
}: MultipleRecommendationsBottomSheetProps) {
  const navigate = useNavigate()
  const { openAllocationSellRecommendationSheet, openRebalanceSellRecommendationSheet } =
    useOpenR2dPlanSellRecommendationSheet()

  useEffect(() => {
    trackEvent({
      eventName: EventNames.KnowMoreBottomSheetLoad,
      payload: {
        eventId: 'MultipleRecommendationsBottomSheet',
        ScreenName: 'REGULAR_TO_DIRECT_PLAN_ELITE_PAGE'
      }
    })
    onReady()
  }, [])

  // Same gate as ListOfCommisionFunds live path: recommended + plan available
  const showAllocation = allocationPlanAvailable && allocationRecommended
  const showRebalance = rebalancePlanAvailable && rebalanceRecommended

  const allocationBanner = showAllocation
    ? getPlanNudgeBanner('allocation', allocationPlanAvailable, timeToAllocationPlanDrop)
    : null
  let rebalanceBanner = showRebalance
    ? getPlanNudgeBanner('rebalance', rebalancePlanAvailable, timeToRebalancePlanDrop)
    : null
  // When both would say Recommended, allocation wins
  if (allocationBanner?.text === 'Recommended' && rebalanceBanner?.text === 'Recommended') {
    rebalanceBanner = null
  }

  // Order: 1 allocation → 2 rebalance → 3 R2D
  const recommendationItems: Array<{
    key: string
    listItemIcon: string
    listItemTitle: string
    listItemDescription: string
    onClick: () => void
    banner: PlanNudgeBanner | null
  }> = []

  if (showAllocation) {
    recommendationItems.push({
      key: 'allocation',
      listItemIcon: AllocationPlanIcon,
      listItemTitle: 'Allocation Plan',
      listItemDescription: 'Switch to a fund that aligns with your ideal allocation strategy',
      banner: allocationBanner,
      onClick: () => {
        trackEvent({
          eventName: EventNames.UserClicked,
          payload: {
            eventId: 'AllocationPlanOption',
            responseName: 'Click',
            screenType: 'REGULAR_TO_DIRECT_PLAN_ELITE_PAGE'
          }
        })
        openAllocationSellRecommendationSheet(isin)
      }
    })
  }

  if (showRebalance) {
    recommendationItems.push({
      key: 'rebalance',
      listItemIcon: RebalancePlanIcon,
      listItemTitle: 'Rebalance Plan',
      listItemDescription: 'Switch to a better performing fund',
      banner: rebalanceBanner,
      onClick: () => {
        trackEvent({
          eventName: EventNames.UserClicked,
          payload: {
            eventId: 'PowerRebalanceOption',
            responseName: 'Click',
            screenType: 'REGULAR_TO_DIRECT_PLAN_ELITE_PAGE'
          }
        })
        if (isNewRebalance) {
          openRebalanceSellRecommendationSheet(isin)
          return
        }
        onDismiss()
        navigate(`/rebalance-plan/${isin}`)
      }
    })
  }

  recommendationItems.push({
    key: 'r2d',
    listItemIcon: RegularToDirectIcon,
    listItemTitle: 'Regular to Direct Plan',
    listItemDescription: 'Switch to direct plan of same fund',
    banner: null,
    onClick: () => {
      trackEvent({
        eventName: EventNames.UserClicked,
        payload: {
          eventId: 'RegularToDirectPlanOption',
          responseName: 'Click',
          screenType: 'REGULAR_TO_DIRECT_PLAN_ELITE_PAGE'
        }
      })
      onDismiss()
      navigate(`/regular-to-direct-plan-elite/${isin}`)
    }
  })

  return (
    <BottomSheetContent
      bottomSheetHeadingClassName="leading-[130%]"
      heading="This fund has multiple recommendations"
      onDismiss={onDismiss}
      bgWhiteRequired={false}
    >
      <div className="flex flex-col gap-3">
        {recommendationItems.map((item) => (
          <RecommendationListItem
            key={item.key}
            banner={item.banner}
            listItemIcon={item.listItemIcon}
            listItemTitle={item.listItemTitle}
            listItemDescription={item.listItemDescription}
            onClick={item.onClick}
          />
        ))}
      </div>
    </BottomSheetContent>
  )
}
